var _rect, _circle, _path, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSmile16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "#8292AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8C3.22386 8 2.99737 8.2245 3.02462 8.4993C3.27516 11.0263 5.40709 13 8 13C10.5929 13 12.7248 11.0263 12.9754 8.4993C13.0026 8.22451 12.7761 8 12.5 8C12.2239 8 12.0033 8.22498 11.9692 8.49901C11.7236 10.4726 10.0402 12 8 12C5.95985 12 4.27643 10.4726 4.03082 8.49901C3.99672 8.22498 3.77614 8 3.5 8Z",
    fill: "#8292AB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1,
    fill: "#8292AB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6,
    r: 1,
    fill: "#8292AB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmile16);
export default __webpack_public_path__ + "static/media/icon_smile_16.caf22037fe78f9f1890cc3fbee0daa36.svg";
export { ForwardRef as ReactComponent };